export const newsTabData = [
  {
    type: 1,
    text: "赛事新闻",
    isImgType: false,
    divideLine: "race-news/m/title-divide.png",
    actImgUrl: "race-news/m/select-1-news.png",
    imgUrl: "race-news/m/no-1-news.png",
  },
  {
    type: 2,
    text: "赛况资讯",
    isImgType: false,
    divideLine: "race-news/m/title-divide.png",
    actImgUrl: "race-news/m/select-2-news.png",
    imgUrl: "race-news/m/no-2-news.png",
  },
];
